var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20285 4.85308L7.81727 5.28317L7.81727 5.28317L7.20285 4.85308ZM6.83786 6.00323L6.86773 6.75263C7.27147 6.73654 7.58989 6.40349 7.58785 5.99944L6.83786 6.00323ZM17.1621 6.00323L16.4122 5.99944C16.4101 6.4035 16.7285 6.73654 17.1323 6.75264L17.1621 6.00323ZM16.7972 4.85308L17.4116 4.42298V4.42298L16.7972 4.85308ZM7.81727 5.28317C8.05118 4.94901 8.43342 4.75 8.84131 4.75V3.25C7.94395 3.25 7.10303 3.68783 6.58842 4.42298L7.81727 5.28317ZM7.58785 5.99944C7.58665 5.76223 7.65475 5.51535 7.81727 5.28317L6.58842 4.42298C6.24397 4.91506 6.08514 5.46644 6.08787 6.00701L7.58785 5.99944ZM3.75 10C3.75 8.24938 5.13442 6.82173 6.86773 6.75263L6.80798 5.25382C4.27336 5.35487 2.25 7.44096 2.25 10H3.75ZM3.75 15V10H2.25V15H3.75ZM7 18.25C5.20507 18.25 3.75 16.7949 3.75 15H2.25C2.25 17.6234 4.37665 19.75 7 19.75V18.25ZM17 18.25H7V19.75H17V18.25ZM20.25 15C20.25 16.7949 18.7949 18.25 17 18.25V19.75C19.6234 19.75 21.75 17.6234 21.75 15H20.25ZM20.25 10V15H21.75V10H20.25ZM17.1323 6.75264C18.8656 6.82174 20.25 8.24938 20.25 10H21.75C21.75 7.44096 19.7266 5.35487 17.192 5.25383L17.1323 6.75264ZM16.1827 5.28317C16.3453 5.51535 16.4134 5.76223 16.4122 5.99944L17.9121 6.00702C17.9149 5.46644 17.756 4.91506 17.4116 4.42298L16.1827 5.28317ZM15.1587 4.75C15.5666 4.75 15.9488 4.94901 16.1827 5.28317L17.4116 4.42298C16.897 3.68783 16.0561 3.25 15.1587 3.25V4.75ZM8.84131 4.75H15.1587V3.25H8.84131V4.75Z",
    fill: "#3B1F8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.c8555cb4494c6aabea8749ce461941fc.svg";
export { ForwardRef as ReactComponent };